import { Action, createReducer, on } from "@ngrx/store";
import { BankState, initialState } from "../state/bank.state";
import * as BankActions from "../actions/bank.actions";


/**
 * Reducer for the bank state
 */
const _bankReducer = createReducer<BankState>(
    initialState,
    on(BankActions.GetBankCountriesSuccess, (state, action): BankState => {
        return {
            ...state,
            bankCountries: [
                ...state.bankCountries,
                { key: action.supplierCode, value: action.countries }
            ]
        }
    })
);

// You need to wrap your reducer as function call like this:
export function BankReducer(state: BankState | undefined, action: Action) {
    return _bankReducer(state, action);
}